import { PWC } from '~/adapters/typescript/propsWithChildren';
import { useFeatureFlagEnabled } from '~/adapters/optimizely/fullstack';
import { useSignalmanFeatureFlag } from '~/contexts/FeatureFlagSignalmanContext';
import { ProfilesSessionGuard } from '~/contexts/Auth/Profiles/ProfilesSessionGuard';
import { AuthErrorBoundary } from '~/contexts/Auth/AuthErrorBoundary';
import { ProfilesProvider } from './Profiles/ProfilesProvider';
import { Auth0ProviderWrapper } from './Auth0/Auth0ProviderWrapper';

export const AuthProvider = ({ children }: PWC) => {
    const optimizelyDecision = useFeatureFlagEnabled('auth0_rollout');
    const signalmanDecision = useSignalmanFeatureFlag('auth0');

    const auth0 = optimizelyDecision || signalmanDecision; // when you are logged out, it is not possible to use `/flags` page to activate `auth0_rollout` feature flag, because Accounts Portal will not render this page. Therefore you can use Profiles signalman to get around this and force auth0

    return (
        <AuthErrorBoundary>
            {auth0 ? (
                <Auth0ProviderWrapper>{children}</Auth0ProviderWrapper>
            ) : (
                <ProfilesProvider>
                    <ProfilesSessionGuard>{children}</ProfilesSessionGuard>
                </ProfilesProvider>
            )}
        </AuthErrorBoundary>
    );
};
